export default "__VITE_ASSET__2cbb6fed__"